// Indian number formatting: ₹1,23,456
export const inr = (value) => `₹${Math.round(Number(value) || 0).toLocaleString('en-IN')}`;

// Compact rupees for axes/tight spaces: ₹950, ₹12.4K, ₹3.2L, ₹1.1Cr
export const inrCompact = (value) => {
    const n = Math.round(Number(value) || 0);
    if (n >= 1e7) return `₹${(n / 1e7).toFixed(1).replace(/\.0$/, '')}Cr`;
    if (n >= 1e5) return `₹${(n / 1e5).toFixed(1).replace(/\.0$/, '')}L`;
    if (n >= 1e3) return `₹${(n / 1e3).toFixed(1).replace(/\.0$/, '')}K`;
    return `₹${n}`;
};

export const shortId = (id) => `#${String(id).slice(-6).toUpperCase()}`;

export const formatDateTime = (date) => new Date(date).toLocaleString('en-IN', {
    day: 'numeric', month: 'short', hour: 'numeric', minute: '2-digit', hour12: true, timeZone: 'Asia/Kolkata'
});

export const formatDay = (isoDay) => new Date(`${isoDay}T00:00:00+05:30`).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', timeZone: 'Asia/Kolkata'
});
